export const ROUND_ORDER = ["Filtros", "Octavos", "Cuartos", "Semis", "Final"];

export function normalizeRound(name) {
  if (!name) return "";
  const lower = String(name).toLowerCase();
  if (lower.includes("filtro")) return "Filtros";
  if (lower.includes("octavo")) return "Octavos";
  if (lower.includes("cuarto")) return "Cuartos";
  if (lower.includes("semi")) return "Semis";
  if (lower.includes("final")) return "Final";
  return name;
}

export function formatDate(fecha) {
  if (!fecha) return "—";
  // Firestore Timestamp
  if (fecha?.toDate) {
    try {
      return fecha.toDate().toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      /* ignore */
    }
  }
  if (typeof fecha === "string") return fecha;
  if (typeof fecha === "number") {
    return new Date(fecha).toLocaleDateString("es-ES");
  }
  return String(fecha);
}

export function formatTime(hora) {
  if (!hora) return "—";
  if (hora?.toDate) {
    try {
      return hora.toDate().toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      /* ignore */
    }
  }
  return String(hora);
}

export function toArray(val) {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === "object") return Object.values(val);
  return [];
}

export function toEntries(val) {
  if (!val) return [];
  if (Array.isArray(val)) return val.map((v, i) => [String(i), v]);
  if (typeof val === "object") return Object.entries(val);
  return [];
}

export function nameOf(v) {
  if (v == null) return "";
  return typeof v === "string" ? v : v?.nombre || v?.name || String(v);
}

// Returns { [participant]: totalPoints } for a vote doc of any supported shape
export function voteScores(vote) {
  const out = {};
  if (!vote) return out;
  if (vote.votes && typeof vote.votes === "object") {
    Object.entries(vote.votes).forEach(([name, stages]) => {
      let total = 0;
      toArray(stages).forEach((arr) =>
        toArray(arr).forEach((p) => {
          const n = parseFloat(p);
          if (!Number.isNaN(n)) total += n;
        })
      );
      out[name] = total;
    });
    return out;
  }
  if (vote.participante) out[vote.participante] = Number(vote.puntos || 0);
  if (vote.a) out[vote.a] = Number(vote.scoreA || 0);
  if (vote.b) out[vote.b] = Number(vote.scoreB || 0);
  return out;
}

export function voteParticipants(vote) {
  if (vote?.participants) return toArray(vote.participants).map(nameOf);
  return Object.keys(voteScores(vote));
}
